import React from "react";

import { useDataList } from "@/lib/useData";

export function useFrequencyType() {
  const [frequencyTypes, isLoading] = useDataList<{ id: number; name: string }>(
    process.env.NEXT_PUBLIC_API_URL + "/api/v1/enum/schedule_frequency",
  );

  const getFrequencyTypeById = React.useCallback(
    (typeId: number) => {
      return frequencyTypes?.find(it2 => typeId === it2?.id);
    },
    [frequencyTypes],
  );

  return { getFrequencyTypeById, frequencyTypes, isLoading };
}
